var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepartmentSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "13 11 21 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/actions/department_sale") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.609375,19.1705753 C14.15625,19.1705753 14.6375,18.8630753 14.8854167,18.3980753 L17.4958333,13.5305753 C17.765625,13.0355753 17.415625,12.4205753 16.8614583,12.4205753 L6.06979167,12.4205753 L5.384375,10.9205753 L3,10.9205753 L3,12.4205753 L4.45833333,12.4205753 L7.08333333,18.1130753 L6.09895833,19.9430753 C5.56666667,20.9480753 6.26666667,22.1705753 7.375,22.1705753 L16.125,22.1705753 L16.125,20.6705753 L7.375,20.6705753 L8.17708333,19.1705753 L13.609375,19.1705753 Z M6.7625,13.9205753 L15.621875,13.9205753 L13.609375,17.6705753 L8.490625,17.6705753 L6.7625,13.9205753 Z M7.375,22.9205753 C6.57291667,22.9205753 5.92395833,23.5955753 5.92395833,24.4205753 C5.92395833,25.2455753 6.57291667,25.9205753 7.375,25.9205753 C8.17708333,25.9205753 8.83333333,25.2455753 8.83333333,24.4205753 C8.83333333,23.5955753 8.17708333,22.9205753 7.375,22.9205753 Z M14.6666667,22.9205753 C13.8645833,22.9205753 13.215625,23.5955753 13.215625,24.4205753 C13.215625,25.2455753 13.8645833,25.9205753 14.6666667,25.9205753 C15.46875,25.9205753 16.125,25.2455753 16.125,24.4205753 C16.125,23.5955753 15.46875,22.9205753 14.6666667,22.9205753 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/actions/department_sale",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "department_sale",
    transform: "translate(13.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    stroke: "#757575",
    strokeWidth: 0.4,
    fill: "#757575",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "storefront",
    transform: "translate(0.500000, 0.079425)",
    fill: "#757575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49683073,-2.27373675e-13 C1.32561024,0.706666667 1.20666667,1.20666667 1.14,1.5 L0.11,5.91 C-0.14,7 0.06,7.92 0.69,8.73 C0.81,8.85 0.93,8.97 1.04,9.07 C1.63,9.64 2.28,10 3.22,10 C4.16,10 4.91,9.59 5.47,9.05 C6.1,9.67 6.86,10 7.8,10 C8.64,10 9.44,9.63 10,9.07 C10.68,9.7 11.45,10 12.3,10 C13.17,10 13.91,9.67 14.54,9.05 C15.11,9.62 15.86,10 16.81,10 C17.76,10 18.43,9.65 19,9.06 C19.09,8.97 19.18,8.87 19.28,8.77 C19.94,7.95 20.14,7 19.89,5.91 L18.86,1.5 C18.7733333,1.20666667 18.6378911,0.706666667 18.4536733,-2.27373675e-13 M16.89,1.97 L17.97,6.38 C18.06,6.81 17.97,7.2 17.69,7.55 C17.44,7.86 17.13,8 16.75,8 C16.44,8 16.17,7.9 15.95,7.66 C15.73,7.43 15.61,7.16 15.58,6.84 L14.97,2 M3.06,2 L5.03,2 L4.42,6.84 C4.3,7.63 3.91,8 3.25,8 C2.84,8 2.53,7.86 2.31,7.55 C2.03,7.2 1.94,6.81 2.03,6.38 M7.05,2 L9,2 L9,6.7 C9,7.05 8.89,7.35 8.64,7.62 C8.39,7.88 8.08,8 7.7,8 C7.36,8 7.07,7.88 6.84,7.59 C6.61,7.3 6.5,7 6.5,6.66 L6.5,6.5 M11,2 L12.95,2 L13.5,6.5 C13.58,6.92 13.5,7.27 13.21,7.57 C12.95,7.87 12.61,8 12.2,8 C11.89,8 11.61,7.88 11.36,7.62 C11.11,7.35 11,7.05 11,6.7",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentSale);
export default __webpack_public_path__ + "static/media/DepartmentSale.c64c9afc.svg";
export { ForwardRef as ReactComponent };